<template>

<div>
	<v-content>
		<v-container fluid>
          <v-flex xs3>
            <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
          </v-flex>
			<v-data-table :headers="headers" :search="search" :items="quoteList" hide-actions class="elevation-1" style="font-size: 10px;">
				<template slot="items" slot-scope="props">
					<td class="text-xs-right" v-for="item in objQuoteSettings" v-if="item.checked"><span @click.prevent="fncEditStatus(props.item,item.id)" v-html="fncFormatColumn(props.item,item.id)"></span></td>
				</template>
			</v-data-table>
		</v-container>
	</v-content>
</div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';

  export default {
	name: 'QuoteList',
    data () {
		return {
			search: '',
			headers: []
		}
	},
	methods: {
		fncFormatColumn(objItem,key) {
			switch(key) {
				case 'sub_total':
					return this.fncFixedRand(objItem.pricing_subtotal);
					break;
				case 'vat':
					return this.fncFixedRand(objItem.pricing_vat);
					break;
				case 'total':
					return this.fncFixedRand(objItem.pricing_total);
					break;
				case 'discount_value':
					return this.fncFixedRand(objItem.discount_val);
					break;
				case 'customer_region':
					return this.fncCheckNull(objItem.customer_region);
					break;
				case 'originator_region':
					return this.fncCheckNull(objItem.originator_region);
					break;
				case 'status':
					return '<strong>'+objItem.status+'</strong>';
					break;
				case 'orig_name':
					return '<strong>'+objItem.orig_name+'</strong>';
					break;
				case 'customer_name':
					return '<strong>'+objItem.customer_name+'</strong>';
					break;
				default:
					return objItem[key];
					break;
			}
		},
		fncFixedRand(val) {
			return 'R' + parseFloat(val).toFixed(2);
		},
		fncCheckNull(val) {
			if( val === null ) {
				return 'N/A';
			} else {
				return val;
			}
		},
		fncShowColumn(col){
		},
		fncEditStatus(objItem, key) {
			if( key === 'status' ) {
			this.$store.dispatch('fncGetQuoteHistory', objItem.id);
				var modalDetails = { title: 'Quote History', component: 'modal-quote-history', mstate: true, params: {} };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
			} else if( key === 'orig_name' ) {
				this.$store.dispatch('fncGetUserInfo', objItem.originator);
				var modalDetails = { title: 'User Information', component: 'modal-user-info', mstate: true, params: {} };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
			}  else if( key === 'customer_name' ) {
				this.$store.dispatch('fncGetUserInfo', objItem.customer);
				var modalDetails = { title: 'User Information', component: 'modal-user-info', mstate: true, params: objItem.customer };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
			}
		}
	},
	computed: {
		...mapGetters([
			'objAuthorize',
			'quoteList',
			'spinePriceList',
			'objQuoteSettings'
		])
	},
	beforeMount() {
		this.$store.dispatch('fncSpinePriceList');
	},
	watch: {
		spinePriceList() {
			this.$store.dispatch('fncPopulateQuoteList');
		},
		quoteList() {
			for( var k in this.objQuoteSettings ) {
				if( this.objQuoteSettings[k].checked === true ) {
					var objHeader = { text: this.objQuoteSettings[k].label, value: this.objQuoteSettings[k].id };
					this.headers.push(objHeader);
				}
			}
		}
	}
}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
